module.exports = __webpack_public_path__ + "static/media/fire-icon@2x.2902f48b.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/icons/fire-icon@2x.png
// module id = 288
// module chunks = 0